import { render } from "./UpdateQuestion.vue?vue&type=template&id=8d6e5a1e&scoped=true"
import script from "./UpdateQuestion.vue?vue&type=script&lang=js"
export * from "./UpdateQuestion.vue?vue&type=script&lang=js"

import "./UpdateQuestion.vue?vue&type=style&index=0&id=8d6e5a1e&scoped=true&lang=css"

import exportComponent from "/home/tek2991/Desktop/Works/Projects/NEW_EPMS/avant-director-production/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d6e5a1e"]])

export default __exports__